/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1LocationStatesId202,
  DeleteApiV1LocationStatesId401,
  DeleteApiV1LocationStatesId404,
  DeleteApiV1LocationStatesId409,
  DeleteApiV1LocationStatesId500,
  DeleteApiV1LocationStatesIdMutationResponse,
  DeleteApiV1LocationStatesIdPathParams,
} from "../../types/locationStateController/DeleteApiV1LocationStatesId.ts";

export const deleteApiV1LocationStatesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1LocationStatesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1LocationStatesId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationStatesId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1LocationStatesId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationStatesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1LocationStatesId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationStatesId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const deleteApiV1LocationStatesId409Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationStatesId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1LocationStatesId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationStatesId500>;

export const deleteApiV1LocationStatesIdMutationResponseSchema = z.lazy(
  () => deleteApiV1LocationStatesId202Schema,
) as unknown as ToZod<DeleteApiV1LocationStatesIdMutationResponse>;
